module.exports = __webpack_public_path__ + "static/demo-session-buddy-f78d9b44da0668b438a62f14c91042d5.mp4";